/**
 * Hero Dual Buttons Template
 *
 * A Framer-inspired centered hero section with heading, subheading, and two buttons.
 */

const heroDualButtons = {
  id: 'hero-dual-buttons',
  name: 'Hero with Dual Buttons',
  category: 'hero',
  description: 'Centered headline with primary and secondary buttons',
  thumbnail: null,
  content: {
    section_type: 'layout-1',
    sectionBackgroundColor: '#ffffff',
    backgroundImage: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '0',
    marginBottom: '0',
    paddingTop: '80',
    paddingBottom: '80',
    paddingLeft: '24',
    paddingRight: '24',
    components: [
      {
        id: 'hero-dual-buttons-row-1',
        type: 'row',
        props: {
          direction: { base: 'horizontal', tablet: null, desktop: null },
          gap: 'md',
          alignment: 'stretch',
          justifyContent: 'center',
          flexWrap: 'wrap',
          columnLayout: { base: 'equal', tablet: null, desktop: null },
          columnWidths: [],
          width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          maxWidth: { base: { value: '600', unit: 'px' }, tablet: null, desktop: null },
          padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
          margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
          backgroundColor: 'transparent',
          backgroundImageUrl: '',
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderRadius: 0,
          overflow: 'visible',
          visibility: { base: true, tablet: null, desktop: null },
          position: 'relative',
          top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          zIndex: 'auto',
          customCSS: '',
        },
        children: [
          {
            id: 'hero-dual-buttons-col-1',
            type: 'column',
            props: {
              gap: 'lg',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 12, tablet: null, desktop: null },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'hero-dual-buttons-heading',
                type: 'text',
                props: {
                  content: 'Meet Framer',
                  element: 'h1',
                  fontFamily: 'System Default',
                  fontSize: 48,
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  letterSpacing: 0,
                  color: '#1a1a1a',
                  textAlign: 'center',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 16, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
              {
                id: 'hero-dual-buttons-subheading',
                type: 'text',
                props: {
                  content: 'Internet canvas.',
                  element: 'p',
                  fontFamily: 'System Default',
                  fontSize: 24,
                  fontWeight: 'normal',
                  lineHeight: 1.5,
                  letterSpacing: 0,
                  color: '#999999',
                  textAlign: 'center',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 24, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
              {
                id: 'hero-dual-buttons-container',
                type: 'container',
                props: {
                  width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: 'transparent',
                  backgroundImageUrl: '',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: 'display: flex; flex-direction: row; gap: 12px; justify-content: center; align-items: center;',
                },
                children: [
                  {
                    id: 'hero-dual-buttons-primary',
                    type: 'button',
                    props: {
                      text: 'Sign Up',
                      url: '',
                      openInNewTab: false,
                      variant: 'primary',
                      size: 'md',
                      fullWidth: false,
                      backgroundColor: '#1a1a1a',
                      textColor: '#ffffff',
                      hoverBackgroundColor: '#333333',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: '600',
                      padding: { base: { top: 12, bottom: 12, left: 24, right: 24, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 8,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'hero-dual-buttons-secondary',
                    type: 'button',
                    props: {
                      text: 'Download',
                      url: '',
                      openInNewTab: false,
                      variant: 'secondary',
                      size: 'md',
                      fullWidth: false,
                      backgroundColor: '#ffffff',
                      textColor: '#1a1a1a',
                      hoverBackgroundColor: '#f5f5f5',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: '600',
                      padding: { base: { top: 12, bottom: 12, left: 24, right: 24, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 1,
                      borderStyle: 'solid',
                      borderColor: '#cccccc',
                      borderRadius: 8,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default heroDualButtons;
